import { useSignupFlowStore } from "../hooks/useSignUpFlowStore";
import { SignupFlowSlug } from "../constants";
import { FieldKey } from "../types";

import { requiredFieldsBySlug } from "./requiredFieldsBySlug";

/**
 * Returns required field keys for a given signup flow page.
 *
 * - Includes all active cats for cat pages.
 * - Falls back to user fields for non-cat pages.
 */

export const getRequiredFieldsForSlug = (slug: SignupFlowSlug): FieldKey[] => {
  const { cats } = useSignupFlowStore.getState();
  const getFieldsForSlug = requiredFieldsBySlug[slug];

  const requiredFields: FieldKey[] = [];

  for (const [ catId, cat ] of Object.entries(cats)) {
    if (!cat.softDelete) {
      const catFields = getFieldsForSlug({ cat, catId });
      requiredFields.push(...catFields);
    }
  }

  if (requiredFields.length === 0) {
    const userFields = getFieldsForSlug({});
    requiredFields.push(...userFields);
  }

  return requiredFields;
};
